var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSystem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F3CC30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7273 11.5C10.7273 12.1904 11.2971 12.75 12 12.75C12.7029 12.75 13.2727 12.1904 13.2727 11.5C13.2727 10.8096 12.7029 10.25 12 10.25C11.2971 10.25 10.7273 10.8096 10.7273 11.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8915 5.51651C13.5007 3.4945 10.4993 3.4945 10.1085 5.51651C9.89192 6.63692 8.69045 7.30642 7.57683 6.92724C5.56707 6.24292 4.06641 8.75157 5.68532 10.0893C6.58237 10.8305 6.58237 12.1695 5.68532 12.9107C4.06641 14.2484 5.56707 16.7571 7.57683 16.0728C8.69045 15.6936 9.89192 16.3631 10.1085 17.4835C10.4993 19.5055 13.5007 19.5055 13.8915 17.4835C14.1081 16.3631 15.3096 15.6936 16.4232 16.0728C18.4329 16.7571 19.9336 14.2484 18.3147 12.9107C17.4176 12.1695 17.4176 10.8305 18.3147 10.0893C19.9336 8.75157 18.4329 6.24292 16.4232 6.92724C15.3096 7.30642 14.1081 6.63692 13.8915 5.51651ZM9.45455 11.5C9.45455 12.8807 10.5942 14 12 14C13.4058 14 14.5455 12.8807 14.5455 11.5C14.5455 10.1193 13.4058 9 12 9C10.5942 9 9.45455 10.1193 9.45455 11.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSystem);
export default __webpack_public_path__ + "static/media/ic_system.31c1dbf1978e9c5df7d377b4a63ef921.svg";
export { ForwardRef as ReactComponent };